import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '312px',
    '& fieldset': {
      width: '100%',
    },
    '& .operandLeftInput': {
      width: '100%',
    },
    '& .operandRightInput': {
      width: '42%',
    },
    '& .operatorInput': {
      width: '16%',
    },
    '& .MuiOutlinedInput-root': {
      position: 'absolute',
      height: '30px',
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      backgroundColor: theme.color.notsocoolgray,
      height: theme.spacer * 3,
      color: theme.color.black,
      borderRadius: `${2}px !important`,
    },
    '& .MuiFilledInput-adornedEnd': {
      paddingRight: theme.spacer,
      height: theme.spacer * 3,
    },
    '& .MuiButton-label': {
      fontSize: "13px",
      fontWeight: "500"
    },
    '& .when-text': {
      fontSize: "13px",
    },
  },
  ExpandMore: {
    '& .MuiSvgIcon-root': {
      width: '20px !important',
    },
  },
  operatorInput2: {
    '& .MuiFilledInput-input': {
      textAlign: 'center',
      padding: '0 !important',
    },
  },
  operandRightInput3: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    '& .MuiSvgIcon-root': {
      width: '20px',
      height: '12px',
      paddingLeft: '8px',
    },
  },
  ListAlt: {
    marginBottom: theme.spacer * 2,
    display: 'flex',
    '& .MuiSvgIcon-root': {
      width: '20px !important',
    },
  },
  conditionFieldSet: {
    padding: theme.spacer,
    marginBottom: theme.spacer * 0,
    paddingBottom: theme.spacer * 2,
    backgroundColor: theme.color.coolgray10,
    borderRadius: theme.spacer * 0.5,
  },
  pl8: {
    paddingLeft: theme.spacer,
  },
  pt2: {
    paddingTop: theme.spacer / 4,
  },
  secionTitle: {
    width: '100%',
    height: '40px',
    backgroundColor: theme.color.coolgray10,
    paddingLeft: '17px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    cursor: 'pointer',
    boxShadow: 'none',
    '& span': {
      fontSize: '13px',
      color: '#000000',
    },
    '& svg': {
      width: '14px !important',
      marginRight: '16px',
    },
    justifyContent: 'space-between',
  },
  radioGroup: {
    '& .MuiFormControlLabel-label': {
      backgroundColor: 'transparent',
      paddingBottom: 0,
    },
  },
  sectionInput:{
    '& .Mui-disabled': {
      backgroundColor: 'rgb(205, 212, 228)',
    },
    '& .MuiInputBase-formControl': {
      height: 25
    },
  },
  sectionRoles:{
    backgroundColor: theme.color.notsocoolgray,
    borderRadius: `${theme.spacer * 0.5}px`,
    lineHeight: `${theme.spacer * 2}px`,
    minHeight: `${theme.spacer * 4}px`,
    margin: `${theme.spacer * 0.5}px`,
    padding: `${theme.spacer * 1}px`,
    wordBreak: 'break-word',
    display: "flex",
    alignItems: "center",
    '& .trash-icon': {
      cursor:"pointer",
      marginLeft: theme.spacer,
      '& path': {
        fill: "#000000"
      }
    }
  },
  conditionTitle: {
    justifyContent: "space-between"
  },
  containerOperand: {
    marginTop: -19, 
    marginBottom: 8 
  },
  containerCases: {
    marginTop: 8
  },
  containerAddMore: {
    marginTop: 8
  },
  containerError: { 
    "& span": {
      marginLeft: '20%'
    }
    
  },
  formControl: {
    justifyContent: 'space-between',
    padding: '12px',
    width: '100%',
  },
  inlineField: {
    display: 'flex',
    marginBottom: '10px',
  },
  inlineFieldLabel: {
    width: '50%',
  },
  textButtonAlignment: {
    position: 'absolute',
    bottom: '20px',
  },
  textButton: {
    height: '28px',
    marginLeft: '10px',
    width: '52px',
    background: `${theme.color.notsocoolgray} !important`,
    borderRadius: '2px !important',
    '& .MuiFilledInput-input': {
      fontSize: '18px'
    }
  },
  fieldControls: {
    background: `${theme.color.coolgray10} !important`,
  },
  btnControls: {
    display: 'flex',
    paddingTop: theme.spacer,
    paddingBottom: theme.spacer,
  },
  noBackground: {
    background: 'none !important',
    '&:hover': {
      background: 'none !important',
    },
    '&:focus': {
      background: 'none !important',
    },
    '& .MuiFilledInput-root.Mui-focused': {
      background: 'none !important',
    },
  },
  formControlField: {
    margin: '5px 2px 20px 2px',
  },
  formControlFieldWithErr: {
    margin: '5px 2px 10px 2px',
  },
  error: {
    color: 'red',
  },
  addButton: {
    fontWeight: 400,
    fontSize: '13px',
    color: theme.color.black,
  },
  dropdownSapLayout: {
    boxShadow: `0px 2px 6px rgba(0, 0, 0, 0.24)`,
    zIndex: '9999 !important',
    borderRadius: '2px',
    '& .MuiAutocomplete-paper': {
      margin: '0px',
      paddingBottom: '0px',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0px',
    },
  },
  dropdownArrowPaper: {
    overflowX: 'unset',
    overflowY: 'unset',
  },
  sapListItem: {
    // minHeight: '160px',
    minHeight: '96px',
    maxHeight: `264px`,
    overflow: 'scroll',
    '& .active': {
      backgroundColor: '#F0F2F7',
    },
  },
  enabledListItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: `${theme.spacer * 20}px`,
    '& .MuiSvgIcon-root': {
      fill: `#666`,
      width: `20px`,
      height: `20px`,
      marginLeft: `${theme.spacer * 1}px`,
    },
  },
  enabledItem: {
    marginTop: `${theme.spacer * 0}px`,
    marginBottom: `${theme.spacer * 0}px`,
    '& .MuiListItemText-root': {
      paddingBottom: `${theme.spacer * 0.5}px`,
      paddingTop: `${theme.spacer * 0.5}px`,
    },
    '& .MuiListItemText-primary': {
      backgroundColor: 'transparent',
      paddingBottom: 0,
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: `${theme.spacer * 3}px`,
    },
    '& .MuiListItemText-primary:hover': {
      backgroundColor: 'transparent',
    },
  },
  systems: {
    width: '100%',
    '& :focus': {
      border: "none"
    }
  }
}));

export default useStyles;
